import React, { useState, useContext, useEffect } from 'react';
// Context
import { UserContext } from '../../../context/UserContext';
import { useLogsData } from '../../../context/LogsContext';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// Components
import Loading from '../../../components/loading/Loading';
import { toastSuccess, toastError } from '../../../components/feedback/Feedback';
// Form
import useInput from '../../../components/form/hooks/useInput';
import DefaultInput from '../../../components/form/inputs/DefaultInput';
import DefaultDatepicker from '../../../components/form/inputs/DefaultDatepicker';
import { isNotEmpty } from '../../../components/form/validator/ValidatorRules';
import { isMandatoryMessage } from '../../../components/form/validator/ValidatorMessages';
import { currencyInputMask } from '../../../components/form/masks/InputMasks';
// Actions
import { save as logSave } from '../../../actions/services';

export default function LogForm({ log, handleCloseModal }) {
  // Form
  const {
    value: agreementdateValue,
    isValid: agreementdateIsValid,
    hasError: agreementdateHasError,
    valueChangeHandler: agreementdateChangeHandler,
    inputBlurHandler: agreementdateBlurHandler,
  } = useInput(isNotEmpty);
  const {
    value: benefitValue,
    isValid: benefitIsValid,
    hasError: benefitHasError,
    valueChangeHandler: benefitChangeHandler,
    inputBlurHandler: benefitBlurHandler,
  } = useInput(isNotEmpty);

  let formIsValid = false;

  if (agreementdateIsValid && benefitIsValid) {
    formIsValid = true;
  }

  // Context
  const { user } = useContext(UserContext);
  const { state, dispatch } = useLogsData();

  // State
  const [isLoading, setIsLoading] = useState(false);

  // useEffect
  useEffect(
    () => {
      if (log) {
        if (log.agreementDate) {
          agreementdateChangeHandler(new Date(log.agreementDate));
        }
        if (log.benefitValue) {
          benefitChangeHandler(log.benefitValue);
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Methods
  const validateAllFormInputs = () => {
    agreementdateBlurHandler();
    agreementdateChangeHandler(agreementdateValue);
    benefitBlurHandler();
    benefitChangeHandler(benefitValue);
  };

  const saveLog = async () => {
    setIsLoading(true);

    await logSave({
      data: {
        ...log,
        condominiumId: log.condominiumId ? log.condominiumId : null,
        agreementDate: new Date(agreementdateValue),
        benefitValue: benefitValue ? benefitValue.replace('.', '').replace(',', '.') : '',
        validationDate: new Date(),
        validationBy: user.id,
      },
      success: (data) => {
        const logIdToUpdate = data;
        let logListArray = state.data.items;
        let logToUpdate = logListArray.find((log) => log.id === logIdToUpdate);

        if (logToUpdate) {
          logToUpdate.benefitValue = benefitValue ? benefitValue.replace('.', '').replace(',', '.') : '';
          logToUpdate.agreementDate = new Date(agreementdateValue);
          logToUpdate.validationDate = new Date();
          logToUpdate.validationBy = user.id;
        }

        toastSuccess('O pedido de subscrição foi atualizado com sucesso');
        setIsLoading(false);
        handleCloseModal();
        dispatch({
          type: 'SET_DATA',
          payload: {
            totalResults: state.data.totalResults,
            items: logListArray,
          },
        });
      },
      error: (error) => {
        toastError('Ocorreu um erro ao submeter o pedido de subscrição');
        setIsLoading(false);
      },
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      validateAllFormInputs();
      return;
    }

    saveLog();
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col>
            <DefaultDatepicker
              label={'Data do contrato'}
              value={agreementdateValue}
              timeFormat={'HH:mm'}
              onChange={agreementdateChangeHandler}
              onBlur={agreementdateBlurHandler}
              hasError={agreementdateHasError}
              errorMessage={isMandatoryMessage}
            />
          </Col>
          <Col>
            <DefaultInput
              label={'Valor benefício (sem IVA)'}
              name={'benefit'}
              required={true}
              extraCharacter={'€'}
              type={'mask'}
              mask={currencyInputMask}
              value={benefitValue}
              onChange={benefitChangeHandler}
              onBlur={benefitBlurHandler}
              hasError={benefitHasError}
              errorMessage={isMandatoryMessage}
            />
          </Col>
        </Row>
        <Row>
          <Col className="text-end">
            <Button type={'submit'}>Submeter pedido</Button>
          </Col>
        </Row>
      </Form>
      {isLoading && <Loading label={'A carregar...'} />}
    </>
  );
}
